module.exports = __webpack_public_path__ + "img/historic-placeholder.336f179c.png";